import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export default function Header() {
  return (
    <header className="border-b border-gray-200 bg-white" data-testid="app-header">
      <div className="ees-container flex items-center justify-between h-14 sm:h-16 relative">
        <Link to="/" className="flex items-center pointer-events-none" data-testid="header-logo">
          <img src="/ees-logo.png" alt="EES Effiziente Energiespeicher" className="h-8 sm:h-9" />
        </Link>
        <Link to="/" className="absolute left-1/2 -translate-x-1/2 bg-[#9ec043] text-white text-xs sm:text-sm font-semibold px-4 py-1.5 rounded-full hover:bg-[#8aad38] transition-colors tracking-wide" data-testid="header-home-link">
          Konfigurator Startseite
        </Link>
        <a href="https://www.ees-energiespeicher.de/" target="_blank" rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#9ec043] transition-colors" data-testid="header-ees-link">
          <span className="hidden sm:inline">Zur EES-Startseite</span>
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </header>
  );
}
